const ACTIVE = "active";
const DRAFT = "draft";
export const SHOPIFY_PRODUCT_STATUS = {
  ACTIVE,
  DRAFT
};
